"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeString = void 0;
var escapeString = function (str) {
    var res = str === null || str === void 0 ? void 0 : str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return res || '';
};
exports.escapeString = escapeString;
